// extracted by mini-css-extract-plugin
module.exports = {"faq-container":"Faq_faq-container__dA_sI","post":"Faq_post__9f2Iz","bordered":"Faq_bordered__aKDuI","paragraph":"Faq_paragraph__vDm6n"};